import { Layer, Source } from '@vis.gl/react-maplibre';
import type { ExpressionSpecification } from 'maplibre-gl';

import { BEFORE_ROUTE_ID } from '@/components/map/RouteLayers';
import { GeoServer } from '@/modules/GeoServer';
import { LEVEL_OF_SERVICE_COLORS } from '@/modules/LevelOfServiceColors';
import { MapLayer } from '@/types/MapLayer';

export function LevelOfServiceLayer() {
  return (
    <Source
      bounds={[7.726052171733736, 49.391684399151906, 10.219795599662884, 51.65640759482277]}
      id={MapLayer.LEVEL_OF_SERVICE}
      tiles={[GeoServer.wmts({ layer: 'vis_live_filtered' })]}
      type="vector"
    >
      <Layer
        key={MapLayer.LEVEL_OF_SERVICE}
        beforeId={BEFORE_ROUTE_ID}
        filter={['==', ['typeof', ['get', 'los']], 'number']}
        id={MapLayer.LEVEL_OF_SERVICE}
        source-layer="vis_live_filtered"
        type="line"
        layout={{
          'line-cap': 'round',
          'line-join': 'round',
        }}
        paint={{
          'line-opacity': ['step', ['zoom'], ['case', ['>', ['get', 'functional_road_class'], 3], 0, 1], 12, 1],
          'line-color': [
            'match',
            ['get', 'los'],
            ...LEVEL_OF_SERVICE_COLORS.map(({ value, color }) => [value, color]).flat(),
            'transparent',
          ] as unknown as ExpressionSpecification,
          'line-width': ['interpolate', ['exponential', 0.5], ['zoom'], 10, 2, 14, 4, 18, 8],
          'line-offset': ['interpolate', ['exponential', 0.5], ['zoom'], 10, 0, 14, 3, 18, 6],
        }}
      />
    </Source>
  );
}
